<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-收款单-修改
    -->
    <el-dialog
    title="收款单"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

 <!-- 在Vue模板中直接绑定字段 -->
<div class="min-h-screen" v-if="!loading">
  <div class="max-w-4xl mx-auto bg-white">
    <!-- 顶部信息区域 -->
    <div class="flex flex-col md:flex-row justify-between mb-8">
      <div class="space-y-1">
        <div class="space-y-1.5 text-sm md:text-base">
          <p class="text-gray-600">订单号：{{ form.order_no }}</p>
          <p class="text-gray-600">订单ID：{{ form.order_id }}</p>
          <p class="text-gray-600">供应商ID：{{ form.supply.supply_id }}</p>
          <p class="text-gray-600" v-if="form.extract_store.store_id">门店ID：{{ form.extract_store.store_id }}</p>

          <p class="text-gray-600">支付方式：{{ form.pay_type.text }}</p>
          <p class="text-gray-600">支付状态：{{ form.pay_status.text }}</p>
          <p class="text-gray-600">订单状态：{{ form.state_text }}</p>


          <p class="text-gray-600">交易流水号：{{ form.transaction_id }}</p>

          <p class="text-gray-600">创建：{{ form.create_time }}</p>
          <p class="text-gray-600">更新：{{ form.update_time }}</p>
        </div>
      </div>
      
      <!-- 状态区域 -->
      <div class="text-sm md:text-base space-y-1.5 text-gray-600">
   
        <p>对账状态：{{ form.reconciliation_text }}</p>
        <p v-if="form.reconciliation_time !== '0'">对账时间：{{form.reconciliation_time }}</p>


      </div>
    </div>
    <!-- 付款方信息 -->
    <section class="bg-gray-50 rounded-xl p-6 mb-6 border border-gray-200">
      <h2 class="text-xl font-semibold mb-4 text-gray-800">付款方信息</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">付款方名称</label>
          {{ form.extract_store.store_name }}
        </div>
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">联系人</label>
          {{ form.user.nickName || '无联系人信息' }}
        </div>
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">联系电话</label>
          {{ form.extract_store.phone }}
        </div>

      </div>
      <div>
        <div class="common-form" v-if="form.pay_type.value == 140">线下付款信息</div>
        <el-row  v-if="form.pay_type.value == 140">
          <el-col :span="5"  v-if="form.pay_setting && form.pay_setting.type == 20">
            <div class="pb16">
              <span class="gray9">姓名</span>
              {{ form.pay_setting.wx_name }}
            </div>
          </el-col>
          <el-col :span="5"  v-if="form.pay_setting && form.pay_setting.type == 20">
            <div class="pb16">
              <span class="gray9">微信账户</span>
              {{ form.pay_setting.wx_account }}
            </div>
          </el-col>


          <el-col :span="5"  v-if="form.pay_setting && form.pay_setting.type == 40">
            <div class="pb16">
              <span class="gray9">姓名</span>
              {{ form.pay_setting.zfb_name }}
            </div>
          </el-col>
          <el-col :span="5"  v-if="form.pay_setting && form.pay_setting.type == 40">
            <div class="pb16">
              <span class="gray9">支付宝账户</span>
              {{ form.pay_setting.zfb_account }}
            </div>
          </el-col>



   
          <el-col :span="5"  v-if="form.pay_setting && form.pay_setting.type == 50">
            <div class="pb16">
              <span class="gray9">姓名</span>
              {{ form.pay_setting.bank_name }}
            </div>
          </el-col>
          <el-col :span="5"  v-if="form.pay_setting && form.pay_setting.type == 50">
            <div class="pb16">
              <span class="gray9">银行信息</span>
              {{ form.pay_setting.bank_account }}
            </div>
          </el-col>

          <el-col :span="5"  v-if="form.pay_setting && form.pay_setting.type == 50">
            <div class="pb16">
              <span class="gray9">银行卡号</span>
              {{ form.pay_setting.bank_card }}
            </div>
          </el-col>




        </el-row>
       </div>

    </section>
    <!-- 商品明细 -->
    <section class="bg-gray-50 rounded-xl p-6 mb-6 border border-gray-200">
      <h2 class="text-xl font-semibold mb-4 text-gray-800">商品明细</h2>
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-100 text-gray-500 text-sm">
            <tr>
              <th class="px-4 py-3 text-left">商品名称</th>
              <th class="px-4 py-3 text-left">规格</th>
              <th class="px-4 py-3 text-right">数量</th>
              <th class="px-4 py-3 text-right">单价</th>
              <th class="px-4 py-3 text-right">金额</th>
              <!-- <th class="px-4 py-3 text-right">实付金额</th> -->
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 text-sm">
            <tr v-for="(item, index) in form.product" :key="index">
              <td class="px-4 py-3">{{ item.product_name || '未命名商品' }}</td>
              <td class="px-4 py-3 text-right">{{ item.product_attr }}</td>
              <td class="px-4 py-3 text-right">{{ item.total_num }}</td>

              <td class="px-4 py-3 text-right">¥{{ parseFloat(item.product_price).toFixed(2) }}</td>
              <td class="px-4 py-3 text-right">¥{{ (item.total_num * item.product_price).toFixed(2) }}</td>
              <!-- <td class="px-4 py-3 text-right">¥{{ (item.total_num * item.product_price).toFixed(2) }}</td> -->
            </tr>
            <tr v-if="form.product.length === 0">
              <td colspan="4" class="text-center py-4 text-gray-500">暂无商品信息</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <!-- 收款信息 -->
    <section class="bg-gray-50 rounded-xl p-6 mb-6 border border-gray-200">
      <h2 class="text-xl font-semibold mb-4 text-gray-800">收款信息</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">应收金额</label>
          <div class="relative" style="font-size: 16px;">
            <span >¥</span>
              {{ parseFloat(form.total_price).toFixed(2) }}
          </div>
        </div>
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">实收金额</label>
          <div class="relative" style="font-size: 16px;">
            <span>¥</span>
            {{ parseFloat(form.pay_price).toFixed(2) }}
          </div>
        </div>
        <div class="md:col-span-2 space-y-2">
          <label class="block text-sm font-medium text-gray-700">支付方式</label>
          <div class="flex flex-wrap gap-4">
            <label class="flex items-center gap-2">
              <input 
                type="radio" 
                :checked="form.pay_type.value === 10" 
                class="form-radio h-4 w-4 text-blue-600"
                disabled
              >
              <span class="text-sm">余额支付</span>
            </label>
            <label class="flex items-center gap-2">
              <input 
                type="radio" 
                :checked="form.pay_type.value === 20" 
                class="form-radio h-4 w-4 text-blue-600"
                disabled
              >
              <span class="text-sm">微信支付</span>
            </label>
            <label class="flex items-center gap-2">
              <input 
                type="radio" 
                :checked="form.pay_type.value === 50" 
                class="form-radio h-4 w-4 text-blue-600"
                disabled
              >
              <span class="text-sm">银行卡支付</span>
            </label>
            <label class="flex items-center gap-2">
              <input 
                type="radio" 
                :checked="form.pay_type.value === 40" 
                class="form-radio h-4 w-4 text-blue-600"
                disabled
              >
              <span class="text-sm">支付宝支付</span>
            </label>
          </div>



      
        </div>
    

      </div>
    </section>
       <!-- 商品明细 -->
       <section class="bg-gray-50 rounded-xl p-6 mb-6 border border-gray-200">
      <h2 class="text-xl font-semibold mb-4 text-gray-800">修改记录</h2>
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-100 text-gray-500 text-sm">
            <tr>
              <th class="px-4 py-3 text-right">修改前金额</th>
              <th class="px-4 py-3 text-right">修改后金额</th>
              <th class="px-4 py-3 text-right">备注</th>
              <th class="px-4 py-3 text-right">操作时间</th>
              <th class="px-4 py-3 text-right">操作人</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 text-sm">
            <tr v-for="(item, index) in form.amountm" :key="index">
              <td class="px-4 py-3">{{ item.old_price }}</td>
              <td class="px-4 py-3 text-right">{{ item.new_price }}</td>
              <td class="px-4 py-3 text-right">{{ item.remark }}</td>
              <td class="px-4 py-3 text-right">{{ item.create_time }}</td>
              <td class="px-4 py-3 text-right">{{ item.shop_user.real_name }}({{ item.shop_user.user_name }})</td>

            </tr>
            <tr v-if="form.amountm.length === 0">
              <td colspan="4" class="text-center py-4 text-gray-500">暂无修改记录</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

 
    <!-- 修改支付金额 -->
    <section class="bg-gray-50 rounded-xl p-6 mb-6 border border-gray-200"
    v-if="form.is_reconciliation == 0 && form.pay_status.value == 20"
    >
      <h2 class="text-xl font-semibold mb-4 text-gray-800">对账确认</h2>
      <div >
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">实付金额</label>
          <div class="relative" style="font-size: 16px;">
            {{ form.pay_price }}
          </div>


          <label class="block text-sm font-medium text-gray-700">最终确认金额</label>
          <div class="relative" style="font-size: 16px;">
            <el-input placeholder="实际支付金额" v-model="form.new_price">
             
            </el-input>
        
          </div>


        <div class="relative" style="font-size: 16px;">
            <el-input type="textarea" placeholder="备注" v-model="form.remark">
             
            </el-input>
          </div>

        
        </div>
      

   
        <el-button type="primary"
        style="margin-top: 20px;float: right;"
        size="small" @click="confirm()" :loading="loading">确 定</el-button>

        <el-button 
        style="margin-top: 20px;float: right;margin-right: 20rpx;"
        size="small" @click="cancelFunc()" :loading="loading">取 消</el-button>

    
        <div style="clear: both;"> </div>
      </div>
    </section>
  </div>
</div>


</el-dialog>
  
</template>

<script>
import Payment_receiptApi from '@/api/payment_receipt.js';

export default {
  components: {
  },
  data() {
    return {
      // 直接从接口获取的原始数据
      form:{
        new_price:0,
        pay_setting:{
          wx_name:"",
          wx_account:"",
          zfb_name:"",
          zfb_account:"",
          bank_name:"",
          bank_account:"",
          bank_card:"",
        }
      }, 
      loading:false,
      type:20,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","order_id"],
  methods: {
    paytypeClick(type){
      this.type = type;
    },
    confirmpay(){
      let self = this;
      let form = self.form;
        self
          .$confirm('线下是否已转账, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
       
            form.order_id = self.order_id;

            self.loading = true;
                Payment_receiptApi.confirmpay(form, true)
                  .then(data => {
                    self.loading = false;
                    self.$message({
                      message: data.msg,
                      type: 'success'
                    });
                    self.dialogFormVisible("error")
                  })
                  .catch(error => {
                    self.loading = false;
                  });
          })
    },
    confirm(){
      let self = this;
      let form = self.form;
        self
          .$confirm('对账之后不再支持对账, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
       
            form.order_id = self.order_id;

            self.loading = true;
                Payment_receiptApi.confirm(form, true)
                  .then(data => {
                    self.loading = false;
                    self.$message({
                      message: data.msg,
                      type: 'success'
                    });
                    self.dialogFormVisible("error")
                  })
                  .catch(error => {
                    self.loading = false;
                  });
          })
  
    },
 
 

   
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Payment_receiptApi.detail({order_id: self.order_id},true).then(res => {
          self.form = res.data;
          self.loading = false;
          self.$set(self.form, 'new_price', Number(self.form.pay_price))
          self.$forceUpdate()
        })
        .catch(error => {});
    },
    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
-webkit-appearance: none;
margin: 0;
}
input[type="date"]::-webkit-calendar-picker-indicator {
cursor: pointer;
padding: 4px;
}
.receipt-form__field {
margin-bottom: 1.5rem;
}
.receipt-form__label {
display: block;
margin-bottom: 0.5rem;
font-weight: 500;
}

</style>



// WEBPACK FOOTER //
// src/views/plus/payment_receipt/index/part/edit.vue